<template>
  <div :class="classes">
    <a
      href="javascript:void(0)"
      v-if="trigger"
      :class="{'btn-open':show}"
      @click="show=!show"
    >
      {{ i18n.common.showHideCode }}
      <fa-icon icon="caret-down" />
    </a>
    <div
      v-show="display"
      class="code-container"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import './show-code.sass'
import { mapState } from 'vuex'

export default {
  name: 'Showcode',
  props: {
    expand: { type: Boolean, default: false },
    trigger: { type: Boolean, default: true }
  },
  data () {
    return {
      show: this.expand
    }
  },
  computed: {
    ...mapState(['i18n']),
    display () {
      if (!this.trigger) return true
      return this.show
    },
    classes () {
      return {
        'show-code': true,
        'code-only': !this.trigger
      }
    }
  }
}
</script>
